import { TRAVEL_PURPOSE } from './otrEnums';

export const TIER_OPTIONS = [
  { value: 1, label: 'Tier 1' },
  { value: 2, label: 'Tier 2' },
  { value: 3, label: 'Tier 3' },
];

export const INITIAL_OTR_FORM_STATE = {
  tierId: 1,
  dateOfTravel: '',
  dateOfReturn: '',
  placeOfTravel: '',
  modeOfTravelId: null,
  purpose: TRAVEL_PURPOSE.CLIENT_MEETING,
  customer: '',
  linkedRecordType: '',
  linkedRecordId: '',
  description: '',
  advanceRequested: '',
  advance: 0,
  companyArranged: false,
  companyArrangedExpenseHeads: {}, // { [expenseHeadId]: boolean }
};

export const INITIAL_EXPENSE_LINE_STATE = {
  expenseHeadId: null,
  amount: 0,
  entryDate: '',
  remarks: '',
  document: null,
};